import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react'
import { localStorageItemKeys } from '~constants/local-storage-items'
import useBreakpoint from '~hooks/use-breakpoint'

export type LeftNavigationVariant = 'primary' | 'secondary'

type NavigationContextType = {
  isOpen: boolean
  setIsOpen: (open: boolean) => void
  navigationVariant: LeftNavigationVariant
  setNavigationVariant: (variant: LeftNavigationVariant) => void
  tourLink: string | undefined
  setTourLink: (link: string | undefined) => void
  tourVesselLink: string | undefined
  setTourVesselLink: (link: string | undefined) => void
}

export const breakpointsWithHamburgerMenu = ['xs', 'sm', 'md']

const NavigationContext = createContext<NavigationContextType | undefined>(
  undefined,
)

export function NavigationProvider({ children }: { children: ReactNode }) {
  const { breakpoint } = useBreakpoint()
  const [isOpen, setIsOpenState] = useState(false)
  const [tourLink, setTourLink] = useState<string>()
  const [tourVesselLink, setTourVesselLink] = useState<string>()
  const [navigationVariant, setNavigationVariant] =
    useState<LeftNavigationVariant>('primary')

  useEffect(() => {
    if (breakpointsWithHamburgerMenu.includes(breakpoint)) {
      setIsOpenState(false)
      return
    }

    const isOpenInStorage = localStorage.getItem(
      localStorageItemKeys.navigationIsOpen,
    )
    if (isOpenInStorage === 'true') {
      setIsOpenState(true)
      return
    } else if (isOpenInStorage === 'false') {
      setIsOpenState(false)
      return
    }

    setIsOpenState(true)
  }, [breakpoint])

  function setIsOpen(open: boolean) {
    setIsOpenState(open)
    localStorage.setItem(localStorageItemKeys.navigationIsOpen, open.toString())
  }
  return (
    <NavigationContext.Provider
      value={{
        isOpen: isOpen || Boolean(tourLink),
        setIsOpen,
        navigationVariant,
        setNavigationVariant,
        tourLink,
        setTourLink,
        tourVesselLink,
        setTourVesselLink,
      }}
    >
      {children}
    </NavigationContext.Provider>
  )
}

export function useNavigation() {
  const context = useContext(NavigationContext)
  if (!context)
    throw new Error('useNavigation must be used within NavigationProvider')
  return context
}
